import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

interface AddSubscriberProps {
    name: string
    recipient_email: string
}

export default async function addSubscriber(params: AddSubscriberProps) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/notifications/add-subscriber/`,
            params,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to add subscriber: ${axiosError.message}`,
            axiosError,
        )

        if (error?.response?.data?.error) {
            throw new Error(error.response.data.error)
        }

        throw new Error(axiosError.message)
    }
}
